var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { createRef, Component } from "react";
import { connect } from "react-redux";
import { set, get, isNull } from "lodash";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H1, Body } from "@irati/ui/src/Typography";
import Success from "@irati/ui/src/Success";
import { IconButton } from "@irati/ui/src/Button";
import selfSignUpService from "@irati-web/platform/src/services/selfSignUp";
import Loading from "@irati/ui/src/Loading";
import Spacing from "@irati/ui/src/Spacing";
import mfaService from "@irati/auth/services/mfa";
import SuccessWithBackLink from "../../../../components/SuccessWithBackLink";
import SelfSignUpPopUp from "../../../../components/Settings/CompanySignUpSettings/SelfSignUp/SelfSignUpPopup";
import DoNotAllow from "../../../../components/Settings/CompanySignUpSettings/SelfSignUp/DoNotAllow";
import EmailDomain from "../../../../components/Settings/CompanySignUpSettings/SelfSignUp/EmailDomain";
import SecretCode from "../../../../components/Settings/CompanySignUpSettings/SelfSignUp/SecretCode";
import SignUpLink from "../../../../components/Settings/CompanySignUpSettings/SelfSignUp/SignUpLink";
import { CODE, EMAIL, NONE, WELCOME_MESSAGE } from "../../../../constants/selfSignUp";
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index(props) {
        var _this = _super.call(this, props) || this;
        _this.selfSignUpPopup = createRef();
        _this.componentDidMount = function () {
            var load = selfSignUpService
                .getSelfSignupByTenant(_this.props.userTenant)
                .then(function (data) {
                _this.setState({
                    selfSignUp: data,
                    show: data.method
                });
            })
                .catch(function () {
                /* no-op, fail silently */
            });
            _this.setState({ load: load });
        };
        _this.get = function () {
            selfSignUpService.getSelfSignupByTenant(_this.props.userTenant).then(function (data) {
                _this.setState({
                    selfSignUp: data
                });
                _this.selfSignUpPopup.current.popup.close();
            });
        };
        _this.handleChange = function (key, value) {
            var selfSignUp = _this.state.selfSignUp;
            set(selfSignUp, key, value);
            _this.setState({ selfSignUp: selfSignUp, changed: true });
        };
        _this.handleSelect = function (show) {
            if (show !== _this.state.show) {
                if (_this.state.changed) {
                    _this.selfSignUpPopup.current.open(show);
                }
                else {
                    _this.setState({ show: show });
                }
            }
        };
        _this.handleSubmit = function (save) {
            if (save === void 0) { save = true; }
            var formatMessage = _this.props.formatMessage;
            var selfSignUp = _this.state.selfSignUp;
            selfSignUp.welcomeMessage = isNull(selfSignUp.welcomeMessage) ? formatMessage({ id: WELCOME_MESSAGE }) : selfSignUp.welcomeMessage;
            var submit = mfaService.hasFlag().then(function () {
                return selfSignUpService
                    .createOrUpdateSelfSignUp(selfSignUp, get(_this.state.selfSignUp, "uuid"))
                    .then(function (data) {
                    _this.setState({ selfSignUp: data });
                    if (save) {
                        _this.save();
                    }
                    else {
                        _this.setState({
                            changed: false
                        });
                    }
                })
                    .catch(function (err) {
                    _this.setState({
                        show: _this.state.selfSignUp.method
                    });
                    throw err;
                });
            });
            _this.setState({ submit: submit });
        };
        _this.handlePopUp = function (show, shouldSave) {
            if (shouldSave) {
                _this.handleSubmit(false);
            }
            else {
                _this.get();
            }
            _this.setState({ show: show, changed: false });
        };
        _this.save = function () {
            var _a = _this.props, onHide = _a.onHide, showBackIcon = _a.showBackIcon;
            _this.setState({ saved: true });
            setTimeout(function () {
                if (showBackIcon) {
                    onHide();
                }
                _this.setState({ saved: false });
            }, 3000);
        };
        _this.state = {
            selfSignUp: {
                tenant: props.userTenant.uuid,
                welcomeMessage: props.formatMessage({ id: WELCOME_MESSAGE })
            },
            show: NONE,
            savedMessage: null,
            load: null,
            submit: null,
            changed: false
        };
        return _this;
    }
    Index.prototype.render = function () {
        var _a = this.state, saved = _a.saved, submit = _a.submit, show = _a.show, load = _a.load, selfSignUp = _a.selfSignUp;
        var _b = this.props, formatMessage = _b.formatMessage, showBackIcon = _b.showBackIcon, backLink = _b.backLink;
        if (saved) {
            return (React.createElement(React.Fragment, null, showBackIcon ? (React.createElement(Success, { message: formatMessage({ id: "admin.containers.selfSignUp.success.message" }) })) : (React.createElement(SuccessWithBackLink, { message: formatMessage({ id: "admin.containers.selfSignUp.success.message" }), backLink: backLink }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Loading, { load: load },
                showBackIcon && React.createElement(IconButton, { onClick: this.props.goBack, icon: "backArrow" }),
                React.createElement(React.Fragment, null,
                    React.createElement(H1, { marginBottom: 4 },
                        React.createElement(FormattedMessage, { id: "admin.containers.selfSignUp.headingTwo.text" })),
                    !selfSignUp || selfSignUp.method === NONE ? (React.createElement(Body, null,
                        React.createElement(FormattedMessage, { id: "admin.containers.selfSignUp.headingFour.text" }))) : (React.createElement(SignUpLink, null)),
                    React.createElement(Spacing, { marginTop: 6 },
                        React.createElement(DoNotAllow, { show: !show || show === NONE, submit: submit, onSelect: this.handleSelect, selfSignUp: selfSignUp, onChange: this.handleChange, onSubmit: this.handleSubmit }),
                        React.createElement(EmailDomain, { show: show === EMAIL, submit: submit, onSelect: this.handleSelect, selfSignUp: selfSignUp, onChange: this.handleChange, onSubmit: this.handleSubmit }),
                        React.createElement(SecretCode, { show: show === CODE, submit: submit, onSelect: this.handleSelect, selfSignUp: this.state.selfSignUp, onChange: this.handleChange, onSubmit: this.handleSubmit })))),
            React.createElement(SelfSignUpPopUp, { ref: this.selfSignUpPopup, onChange: this.handlePopUp })));
    };
    Index.defaultProps = {
        showBackIcon: true
    };
    return Index;
}(Component));
var mapStateToProps = function (_a) {
    var auth = _a.auth;
    return {
        userTenant: auth.userTenant
    };
};
export default injectIntl(connect(mapStateToProps)(Index));
